/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  RoomUtilizationControllerFindAllV1200AllOf,
  RoomUtilizationControllerFindAllV1Params,
  RoomUtilizationControllerFindAllV1PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class RoomUtilizationService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Get Room Utilization table
   */

  findAll<TData = RoomUtilizationControllerFindAllV1200AllOf>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: RoomUtilizationControllerFindAllV1PathParameters,
    params: RoomUtilizationControllerFindAllV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/uc-monitoring/v1/clients/${clientId}/room-utilization`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
}
